<template>
  <div>
    <h6
      v-if="profileId == 0"
      class="heading-small text-muted mb-4 text-truncate"
    >
      Add New Company {{ inputName ? " - " + this.inputName : "" }}
    </h6>
    <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">
      View Company - {{ this.inputName }}
    </h6>
    <h6 v-else class="heading-small text-muted mb-4 text-truncate">
      Edit Company - {{ this.inputName }}
    </h6>

    <base-alert v-if="errors.length" type="danger">
      <b>You have the following error(s):</b>
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <b-tabs
      v-show="profileId != 0 && this.$attrs.viewMode == true"
      content-class="mt-3"
    >
      <b-tab title="Details" active v-on:click="openDetails"></b-tab>
      <b-tab title="History" v-on:click="openHistory">
        <!-- <b><label>Created By: </label></b>
        {{ inputCreatedBy }} | {{ inputCreatedAt | dateFilter }}
        <br />
        <b><label>Updated By:</label></b>
        {{ inputUpdatedBy }} | {{ inputUpdatedAt | dateFilter }} -->
        <div>
            <a-table :columns="historyColumns" :dataSource="historyData" size="small" />
        </div>
      </b-tab>
    </b-tabs>

    <form id="form-proper">
      <!-- {{bagger}} -->
      <div v-if="customFormMode == 1" v-show="showDetails">
        <base-input
          alternative=""
          label="Company Code"
          placeholder=""
          v-model="inputCode"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Name"
          placeholder=""
          v-model="inputName"
          input-classes="form-control"
          required
        />
        <base-input alternative="" label="Address" placeholder="">
          <textarea
            v-model="inputAddress"
            rows="4"
            class="form-control"
            required
            style="resize:none;"
          />
        </base-input>
        <base-input
          alternative=""
          label="Contact Person"
          placeholder=""
          v-model="inputContactPerson"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Position"
          placeholder=""
          v-model="inputContactPosition"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Telephone Number"
          placeholder=""
          v-model="inputTelephone"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Fax Number"
          placeholder=""
          v-model="inputFax"
          input-classes="form-control"
        />
        <base-input alternative="" label="Remark">
          <textarea rows="4" class="form-control" v-model="inputRemark" />
        </base-input>
        <base-input
          alternative=""
          label="TIN Number"
          placeholder=""
          v-model="inputTin"
          input-classes="form-control"
          required
        />
      </div>
      <div v-if="customFormMode == 2">
        <!-- Override -->
        <dynamic-form
          :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
          :formSettings="company"
          @valueUpdated="updateSettings"
          :key="dynamicFormKey"
        />
      </div>
      <div v-if="customFormMode == 3">
        <!-- Append -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <base-input
              alternative=""
              label="Company Code"
              placeholder=""
              v-model="inputCode"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="inputName"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Address"
              placeholder=""
              v-model="inputAddress"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Contact Person"
              placeholder=""
              v-model="inputContactPerson"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Position"
              placeholder=""
              v-model="inputContactPosition"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Telephone Number"
              placeholder=""
              v-model="inputTelephone"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Fax Number"
              placeholder=""
              v-model="inputFax"
              input-classes="form-control"
            />
            <base-input alternative="" label="Remark">
              <textarea rows="4" class="form-control" v-model="inputRemark" />
            </base-input>
            <base-input
              alternative=""
              label="TIN Number"
              placeholder=""
              v-model="inputTin"
              input-classes="form-control"
              required
            />
          </a-tab-pane>
          <a-tab-pane tab="Custom Fields" key="2" forceRender>
            <dynamic-form
              :convertedJson="{
                mode: customForm.mode,
                groups: customForm.groups_append,
              }"
              :formSettings="company"
              @valueUpdated="updateSettings"
              :key="dynamicFormKey"
              :showErrors="false"
            />
          </a-tab-pane>
        </a-tabs>
      </div>

      <div class="mt-5" v-if="this.$attrs.viewMode != true">
        <!-- Button  -->
        <div
          v-if="serverType == 'ho'"
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            v-if="profileId == 0"
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="create"
          >
            Create
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="update"
          >
            Update
          </button>
        </div>
        <div
          v-else
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="$emit('closeDrawer', null)"
          >
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import DynamicForm from "../DynamicForm.vue";
import ValidateField from "../../components/validateFormUtils.js";
import { mapState } from "vuex";
import moment from "moment";
var component_x;

const company_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];

export default {
  components: {
    DynamicForm,
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
  },
  mounted: async function() {
    // Meta-data Call
    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Company?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }

    if (this.serverType == "branch" || this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }
    }
    component_x = this;
    if (component_x.profileId > 0) {
      var data = await HTTPRequest.getRequest(
        component_x.endPoint + "companies/" + component_x.profileId,
        null
      );
      if (data == undefined) {
        component_x.$router.go();
      } else {
        if (data["error"] == undefined) {
          component_x.inputCode = data["code"];
          component_x.inputName = data["name"];
          component_x.inputAddress = data["address"];
          component_x.inputContactPerson = data["contact_person"];
          component_x.inputContactPosition = data["contact_position"];
          component_x.inputTelephone = data["telephone"];
          component_x.inputFax = data["fax"];
          component_x.inputRemark = data["remark"];
          component_x.inputTin = data["tin"];
          component_x.inputCreatedBy = data["created_by"];
          component_x.inputCreatedAt = data["created_at"];
          component_x.inputUpdatedBy = data["updated_by"];
          component_x.inputUpdatedAt = data["updated_at"];
        } else {
          this.errors = data["error"].split(","); //format will change when error message has comma
          //component_x.$router.push("/")
        }
      }
    }
    this.dynamicFormKey++;
  },
  data: function() {
    return {
      inputCode: "",
      inputName: "",
      inputAddress: "",
      inputContactPerson: "",
      inputContactPosition: "",
      inputTelephone: "",
      inputFax: "",
      inputRemark: "",
      inputTin: "",
      inputCreatedBy: "",
      inputCreatedAt: "",
      inputUpdatedBy: "",
      inputUpdatedAt: "",
      showDetails: true,
      errors: [],
      // FOR META-DATA
      customFormMode: 1,
      customForm: {},
      profileData: {},
      dynamicFormKey: 0,
      company: {},
      formErrors: [],

      historyVisible: false,
      historyColumns: company_histories_column,
      historyData: null,
      loading: false,
      pagination: false
    };
  },
  filters: {
    dateFilter: function(timestamp) {
      return moment(timestamp).format("L LTS");
    },
  },
  methods: {
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.company;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;

      if (this.customFormMode == 3) {
        this.errors = errors;
      }

      this.company = mergedHash;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    openDetails() {
      this.showDetails = true;
    },
    async openHistory() {
      this.showDetails = false
      let company_id = this.profileId
      let companyHistory = await HTTPRequest.getRequest(this.endPoint + "company_update_histories?company_id=" + company_id, null, null);
      this.historyData = companyHistory
    },
    validateForm() {
      this.errors = [];
      // this.errors.push(ValidateField.required('Company Code', this.inputCode));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Company Code', this.inputCode));
      this.errors.push(ValidateField.required("Name", this.inputName));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
      this.errors.push(ValidateField.required("Address", this.inputAddress));
      this.errors.push(
        ValidateField.alphanumericWithSpecialChars("Address", this.inputAddress)
      );
      this.errors.push(
        ValidateField.phoneNumberFormat("Telephone", this.inputTelephone)
      );
      this.errors.push(ValidateField.phoneNumberFormat("Fax", this.inputFax));
      this.errors.push(
        ValidateField.alphabetWithSpace(
          "Contact Person",
          this.inputContactPerson
        )
      );
      this.errors.push(
        ValidateField.alphanumericWithSpecialChars(
          "Position",
          this.inputContactPosition
        )
      );
      this.errors.push(ValidateField.required("TIN Number", this.inputTin));
      this.errors.push(
        ValidateField.alphanumericWithSpecialChars("TIN Number", this.inputTin)
      );
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      return this.errors.length;
    },
    create: async function() {
      if (!this.validateForm()) {
        var companyPayload = {
          company: {
            name: this.inputName.trim(),
            code: this.inputCode.trim(),
            address: this.inputAddress,
            contact_person: this.inputContactPerson,
            contact_position: this.inputContactPosition,
            telephone: this.inputTelephone,
            fax: this.inputFax,
            remark: this.inputRemark,
            tin: this.inputTin,
          },
        };
        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "companies",
          null,
          companyPayload
        );
        if (post_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (post_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = post_request["error"].split(","); //format will change when error message has comma
            //this.$router.push("/")
          }
        }
      }
    },
    update: async function() {
      if (!this.validateForm()) {
        var companyPayload = {
          company: {
            name: this.inputName.trim(),
            code: this.inputCode.trim(),
            address: this.inputAddress,
            contact_person: this.inputContactPerson,
            contact_position: this.inputContactPosition,
            telephone: this.inputTelephone,
            fax: this.inputFax,
            remark: this.inputRemark,
            tin: this.inputTin,
          },
        };
        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "companies/" + this.profileId,
          null,
          companyPayload
        );
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = put_request["error"].split(","); //format will change when error message has comma
            //this.$router.push("/")
          }
        }
      }
    },
  },
};
</script>

<style></style>